<template>
  <div>
    <v-toolbar class="white pa-1 elevation-2">
      <v-toolbar-side-icon @click.stop="changeDrawer()"></v-toolbar-side-icon>
      <img src="../assets/logo.png" alt="logo" class="logo">
      <v-toolbar-title></v-toolbar-title>

      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn flat to="/">Home</v-btn>
        <v-btn flat to="/booking">{{$t("home.book")}}</v-btn>
        <v-btn flat to="/rooms">{{$t("home.rooms")}}</v-btn>
        <v-btn flat to="/services">{{$t("home.services")}}</v-btn>
        <v-btn flat to="/contact">{{$t("home.contact")}}</v-btn>
          <v-btn flat to="/promo">
            <v-icon color="pink" class="promo">local_offer</v-icon>
            {{$t("home.promo")}}
          </v-btn>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>language</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-tile @click="">
              <v-list-tile-action>
                <v-icon>fas fa-flag</v-icon>
              </v-list-tile-action>

              <v-list-tile-content @click="$i18n.locale = 'it'">
                <v-list-tile-title>IT</v-list-tile-title>
                <v-list-tile-sub-title>Italiano</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile @click="">
              <v-list-tile-action>
                <v-icon>fas fa-flag</v-icon>
              </v-list-tile-action>

              <v-list-tile-content @click="$i18n.locale = 'en'">
                <v-list-tile-title>EN</v-list-tile-title>
                <v-list-tile-sub-title>English</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  data(){
    return{
      
    }
  },
  methods: {
    changeDrawer: function(){
      this.$emit('drawering');
    }
  }
}
</script>

<style scoped>
.logo{
  width: 115px;
  height: auto;
}

.promo{
    font-size: 28px;
    position: absolute;
    top: 5px;
    right: -24px;
}
</style>